import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { CallChartData, LoadAnalyticsPayload } from "./types";

interface AsyncState<T> {
  data: T | null;
  loading: boolean;
  error: boolean;
}

export interface AnalyticsState {
  analytics: AsyncState<CallChartData[]>;
}

export const initialState: AnalyticsState = {
  analytics: { data: null, loading: false, error: false },
};

export const analyticsSlice = createSlice({
  name: "analytics",
  initialState,
  reducers: {
    loadAnalytics(
      state,
      _action: PayloadAction<LoadAnalyticsPayload | undefined>,
    ) {
      state.analytics.loading = true;
      state.analytics.error = false;
    },
    analyticsLoaded(state, { payload }: PayloadAction<CallChartData[]>) {
      state.analytics.data = payload;
      state.analytics.loading = false;
      state.analytics.error = false;
    },
    loadAnalyticsError(state) {
      state.analytics.loading = false;
      state.analytics.error = true;
    },
  },
});

export const { loadAnalytics, analyticsLoaded, loadAnalyticsError } =
  analyticsSlice.actions;

export const { reducer } = analyticsSlice;
